interface TableHeaderProps {
  title: string;
  subtitle?: string;
}

export function TableHeader({ title, subtitle }: TableHeaderProps) {
  return (
    <div className="flex items-center justify-between">
      <div className="flex flex-col gap-1.5">
        <h2 className="text-base font-semibold text-zinc-950">{title}</h2>
        {subtitle && <p className="text-sm text-zinc-500">{subtitle}</p>}
      </div>
    </div>
  );
}
